import React, { useMemo, useState } from "react";
import Button from "../../../components/shared/buttons/button";
import GridCard from "../../../components/shared/gridCard/GridCard";
import CaseDarkOrange from "../../../images/case_dark_orange.svg";
import CaseOrange from "../../../images/case_orange.svg";
import Box from "../../../images/boxes.svg";
import BoxGreen from "../../../images/box_green.svg";
import Reprocessing from "../../../images/reprocessing.svg";

import { Col, Row } from "react-bootstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TotalEmployee from "../../../images/total_emp.svg";

import InfoCard from "../../../components/shared/infocard/InfoCard";
import PackingCharts from "./PackingCharts";
import {
  useGetPackingSummaryQuery,
} from "../packing/packingApi";
import DateSelector from "../../../components/shared/fields/DateSelector";
import {
  useGetAllWorkingAreasQuery,
} from "../../../app/globalApi";
import { skipToken } from "@reduxjs/toolkit/query";
import GridCardNew from "../../../components/shared/gridCard/GridCardNew";
import EmployeeWashing from "../../../images/emp_washing.svg";
import useTranslator from "../../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate, makePriorLotNumber } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const PackingDashboard = () => {
  const { _t } = useTranslator();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const lotNumber = makePriorLotNumber(date);

  const [packingTab, setPackingTab] = useState("packing_overview");

  let filterMap = {
    Today: "hourly",
    Weekly: "weekly",
    Monthly: "monthly",
  };
  const [packingFilter, setPackingFilter] = useState("monthly");
  const [matricsFilter, setMatricsFilter] = useState("monthly");
  const { data: summaryData } = useGetPackingSummaryQuery({
    tab: "dashboard",
    date,
  });
  const { data: employeeSummaryData } = useGetPackingSummaryQuery({
    tab: "employees_log",
    date: currentDate,
  });
  const { data: packingChart } = useGetPackingSummaryQuery({
    tab: packingTab,
    filter: packingFilter,
  });
  const { data: matricsData } = useGetPackingSummaryQuery({
    tab: "matrics",
    filter: matricsFilter,
  });

  const { data: workingAreasData, isLoading: isWorkingAreasLoading } =
    useGetAllWorkingAreasQuery();

  const receivingAreaId = useMemo(() => {
    if (!workingAreasData?.data) return null;
    const receivingArea = workingAreasData.data.find(
      (area) => area.name === "Packing Area"
    );
    return receivingArea ? receivingArea.id : null;
  }, [workingAreasData]);

  // const {
  //   data: attendanceOverviewData,
  //   isLoading: isAttendanceLoading,
  //   isError: isAttendanceError,
  // } = useGetAttendanceOverviewQuery(
  //   receivingAreaId
  //     ? { working_area_id: receivingAreaId, date: date }
  //     : skipToken
  // );

  // const attendanceListItems = useMemo(() => {
  //   if (!attendanceOverviewData?.data) return [];

  //   const items = [
  //     {
  //       label: _t("total_employees", "Total Employees"),
  //       value: attendanceOverviewData.data.total_employees,
  //       icon: TotalEmployee,
  //     },
  //   ];

  //   for (const [role, count] of Object.entries(
  //     attendanceOverviewData.data.roles
  //   )) {
  //     items.push({
  //       label: role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()), // format label
  //       value: count,
  //       icon: EmployeeWashing,
  //     });
  //   }

  //   return items;
  // }, [attendanceOverviewData]);

  const data = {
    cheeks: [
      {
        label: _t("cheeks_prime_percentage_from_ovens", "Cheek % Prime From Ovens"),
        value: `${(
          matricsData?.data?.cheeks_prime_percentage_from_ovens ?? 0
        ).toFixed(2)}%`,
      },
      {
        label: _t("kg_per_case_cheek", "KG Per Case Cheek"),
        value: `${(matricsData?.data?.cheeks_kg_per_case ?? 0).toFixed(2)}KG`,
      },
      {
        label: _t("total_prime_percentage_eod", "Total Prime % End of Day"),
        value: `${(
          matricsData?.data?.cheeks_total_prime_percentage_eod ?? 0
        ).toFixed(2)}%`,
      },
      // {
      //   label: "Not Prime Per Case",
      //   value: `${(matricsData?.data?.cheeks_not_prime_per_case ?? 0).toFixed(
      //     2
      //   )}`,
      // },
    ],

    strips: [
      {
        label: _t("strips_prime_percentage_from_ovens", "Strips % Prime From Ovens"),
        value: `${(
          matricsData?.data?.strips_prime_percentage_from_ovens ?? 0
        ).toFixed(2)}%`,
      },
      {
        label: _t("kg_per_case_strip", "KG Per Case Strip"),
        value: `${(matricsData?.data?.strips_kg_per_case ?? 0).toFixed(2)}KG`,
      },
      {
        label: _t("strips_total_prime_percentage_eod", "Total Prime % End of Day"),
        value: `${(
          matricsData?.data?.strips_total_prime_percentage_eod ?? 0
        ).toFixed(2)}%`,
      },
      // {
      //   label: "Not Prime Per Case",
      //   value: `${(matricsData?.data?.strips_not_prime_per_case ?? 0).toFixed(
      //     2
      //   )}`,
      // },
    ],
  };

  const total =
    Number(packingChart?.data.total_prime) +
    Number(packingChart?.data.not_prime) +
    Number(packingChart?.data.trash);

  const optionsDonut = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
    },
    title: {
      text: `${isNaN(total) ? "0" : total ?? 0} <br> ${_t("total_prime", "Total Prime")}  <br>`,
      align: "center",
      verticalAlign: "middle",
      y: 60,
      style: {
        fontSize: "1.1em",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>",
    },
    accessibility: {
      point: {},
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        startAngle: -90,
        endAngle: 90,
        center: ["50%", "75%"],
        size: "110%",
        showInLegend: true,
      },
    },
    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom",
      itemMarginBottom: 5,
      itemStyle: {
        color: "#8C97A7",
        fontSize: "14px",
      },
    },
    series: [
      {
        type: "pie",
        name: _t("prime_overview", "Prime Overview"),
        innerSize: "50%",
        data: [
          {
            name: _t("total_prime", "Total Prime"),
            y: (packingChart?.data.total_prime / total) * 100,
            color: "#FFEED4",
          },
          {
            name: _t("not_prime", "Not Prime"),
            y: (packingChart?.data.not_prime / total) * 100,
            color: "#25AA91",
          },
          {
            name: _t("trash", "Trash"),
            y: (packingChart?.data.trash / total) * 100,
            color: "#BB001D",
          },
        ],
      },
    ],
  };
  const listItems = [
    {
      label: _t("total_cheeks_entered", "Total Cheeks entered"),
      value: summaryData?.data.total_cheeks_entered,
      icon: CaseOrange,
    },
    {
      label: _t("total_strips_entered", "Total Strips Entered"),
      value: summaryData?.data.total_strips_entered,
      icon: CaseDarkOrange,
    },
    {
      label: _t("total_prime", "Total Prime"),
      value: summaryData?.data.total_prime,
      icon: Box,
    },
    {
      label: _t("total_kg_not_prime", "Total Kg Not Prime"),
      value: summaryData?.data.total_kg_not_prime,
      icon: BoxGreen,
    },

    {
      label: _t("total_boxes_packed", "Total Boxes Packed"),
      value: summaryData?.data.total_boxes_packed,
      icon: Box,
    },
    {
      label: _t("total_cheeks_boxes_packed", "Total Cheek Boxes Packed"),
      value: summaryData?.data.total_cheeks_boxes_packed,
      icon: CaseOrange,
    },
    {
      label: _t("total_strips_boxes_packed", "Total Stripe Boxes Packed"),
      value: summaryData?.data.total_strips_boxes_packed,
      icon: CaseDarkOrange,
    },
  ];
  const handlePieFilter = (selectedFilter) => {
    setPackingFilter(filterMap[selectedFilter]);
  };
  const handleMatricsFilter = (selectedFilter) => {
    setMatricsFilter(filterMap[selectedFilter]);
  };
  
  return (
    <div>
      {" "}
      <div className="overview cmn_card">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
          <div className="d-flex gap-2 align-items-center">
            <h6 className="mb-0">{_t("lot_number", "Lot Number")}</h6>
            <Button
              // onClick={AddEmployee}
              label={`#${lotNumber}`}
              size="small"
              className="borderRedBtn"
            />
            <DateSelector setDate={setDate} />
          </div>
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <Row className="mt-3 mb-3">
        <Col lg={6}>
          <div className="cmn_card h-100">
            <div className="overview_header d-flex gap-2 align-items-center">
              <h6 className="mb-0 flex-grow-1">{_t("packing_overview", "Packing Overview")}</h6>
              <ul className="chart_filter">
                {["Today", "Weekly", "Monthly"].map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handlePieFilter(item)}
                    className={
                      filterMap[item] === packingFilter ? "active" : ""
                    }
                  >
                    {_t(item, item)}
                  </li>
                ))}
              </ul>
            </div>
            <div className="p-2">
              <HighchartsReact highcharts={Highcharts} options={optionsDonut} />
            </div>
          </div>
        </Col>
        <Col lg={6}>
          <div className="cmn_card h-100">
            <div className="overview_header d-flex gap-2 align-items-center">
              <h6 className="mb-0 flex-grow-1">{_t("matrix_overview", "Matrix Overview")}</h6>
              <ul className="chart_filter">
                {["Today", "Weekly", "Monthly"].map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleMatricsFilter(item)}
                    className={
                      filterMap[item] === matricsFilter ? "active" : ""
                    }
                  >
                    {_t(item, item)}
                  </li>
                ))}
              </ul>
            </div>
            <div className="p-2 position-relative">
              <Row>
                <Col lg={6} className="border-end">
                  <h6 className="my-3">{_t("cheeks", "Cheeks")} </h6>

                  <Row>
                    {data.cheeks.map((item, index) => (
                      <Col lg={12} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </Col>
                <Col lg={6}>
                  <h6 className="my-3">{_t("strips", "Strips")}</h6>
                  <Row>
                    {data.strips.map((item, index) => (
                      <Col lg={12} key={index}>
                        <InfoCard label={item.label} value={item.value} />
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      <PackingCharts />
    </div>
  );
};

export default PackingDashboard;
